import { BACKEND_API_URL } from "~/constants";

/**
 * ログイン成功レスポンス
 */
export interface LoginSuccessResponse {
  success: boolean;
}

/**
 * ログアウトレスポンス
 */
export interface SignOutResponse {
  success: boolean;
}

/**
 * 認証APIリポジトリ
 */
export class BackendAuthRepository {
  /**
   * 認証成功時に監査ログを記録する
   */
  async resetFailedLoginAttempts(token: string): Promise<LoginSuccessResponse> {
    const url = new URL(`${BACKEND_API_URL}/v1/auth/login/success`);

    const response = await fetch(url.toString(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({
        detail: "ログイン成功の記録に失敗しました",
      }));
      throw new Error(error.detail || "ログイン成功の記録に失敗しました");
    }

    return await response.json();
  }

  /**
   * ログアウト処理を実行し、監査ログを記録する
   */
  async signOut(token: string): Promise<SignOutResponse> {
    const url = new URL(`${BACKEND_API_URL}/v1/auth/logout`);

    const response = await fetch(url.toString(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({
        detail: "ログアウト処理に失敗しました",
      }));
      throw new Error(error.detail || "ログアウト処理に失敗しました");
    }

    return await response.json();
  }
}
